import { CloseOutlined } from "@ant-design/icons";
import {
  Dialog,
  Typography,
  IconButton,
  Paper,
  Grid,
  Divider,
  Chip,
  DialogContent,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import { memberTypewiseSectionConfigView } from "../types/memberTypewiseSectionConfigView";
import { ModalProp, useDialogLoader } from "contexts/DialogLoader";
import dayjs from "dayjs";
import CircularWithPath from "components/@extended/progress/CircularWithPath";

const View = ({
  open,
  isFetching,
  model,
}: ModalProp<memberTypewiseSectionConfigView>) => {
  const { handleCancel } = useDialogLoader<memberTypewiseSectionConfigView>();
  return (
    <Dialog open={open} onClose={handleCancel} fullWidth maxWidth="md">
      <DialogContent>
        {isFetching ? (
          <Box sx={{ p: 5 }}>
            <Stack direction="row" justifyContent="center">
              <CircularWithPath />
            </Stack>
          </Box>
        ) : (
          <>
            <Stack direction={"row"} justifyContent={"space-between"}>
              <Stack direction="row" spacing={2} marginBottom={4} my={"0px"}>
                <Typography variant="h4" >
                  Section Config
                </Typography>
                <Typography variant="h4"> | </Typography>
                <Typography variant="h4" color={"rgb(60,117,201)"}>
                  {model?.sectionName}
                </Typography>
              </Stack>
              <IconButton onClick={handleCancel}>
                <CloseOutlined />
              </IconButton>
            </Stack>
            <Divider />
            <Paper sx={{ mt: 2 }}>
              <Typography
                variant="h5"
                bgcolor={"rgb(239,242,249)"}
                color={"rgb(60,117,201)"}
                sx={{ px: 2.5, py: 1 }}
              >
                Section Config Information
              </Typography>

              <Grid container sx={{ padding: "16px" }}>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Member Type :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.memberTypeName}
                  </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Section :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">{model?.sectionName} </Typography>
                </Grid>

                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Overnight Issue Max Item :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.overnightIssueMaxItems}
                  </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  On Premises Issue End Time :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.modified
                      ? dayjs(model?.onPremisesIssueEndTime).format("hh:mm A")
                      : " "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Is Overnight Issue :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.isOvernightIssue ? (
                      <Chip
                        sx={{ borderRadius: 10 }}
                        label="Yes"
                        size="small"
                        color="success"
                        variant="filled"
                      />
                    ) : (
                      <Chip
                        sx={{ borderRadius: 10 }}
                        label="No"
                        size="small"
                        color="error"
                        variant="filled"
                      />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Is On Premises Issue :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.isOnPremisesIssue ? (
                      <Chip
                        sx={{ borderRadius: 10 }}
                        label="Yes"
                        size="small"
                        color="success"
                        variant="filled"
                      />
                    ) : (
                      <Chip
                        sx={{ borderRadius: 10 }}
                        label="No"
                        size="small"
                        color="error"
                        variant="filled"
                      />
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>

            <Paper sx={{ mt: 2 }}>
              <Typography
                variant="h5"
                bgcolor={"rgb(239,242,249)"}
                color={"rgb(60,117,201)"}
                sx={{ px: 2.5, py: 1 }}
              >
                Other Information
              </Typography>
              <Grid container sx={{ padding: "16px" }}>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Created :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.created
                      ? dayjs(model?.created).format("DD-MM-YYYY hh:mm A")
                      : " "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Modified :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">
                    {model?.modified
                      ? dayjs(model?.modified).format("DD-MM-YYYY hh:mm A")
                      : " "}
                  </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  Library :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">{model?.libraryName} </Typography>
                </Grid>
                <Grid
                  item
                  textAlign={"right"}
                  xs={5}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  User :
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={3}
                  sx={{
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                    padding: "5px",
                  }}
                >
                  <Typography color="#3598DC">{model?.userName} </Typography>
                </Grid>
              </Grid>
            </Paper>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default View;
